const renderTitle = (title) =>
  title.split('|').map((part, index) =>
    index % 2 === 1
      ? <span className="accent" key={index}>{part}</span>
      : <span key={index}>{part}</span>,
  );

export const SectionHeading = ({ eyebrow, title, align = 'left' }) => (
  <div className={`section-heading section-heading--${align}`}>
    <span className="eyebrow">{eyebrow}</span>
    <h2>{renderTitle(title)}</h2>
  </div>
);
